"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsrTabGenerator = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const constants_1 = require("../../../question/constants");
const defaultGenerator_1 = require("../defaultGenerator");
const generator_1 = require("../generator");
const templateNames_1 = require("../templates/templateNames");
// For the APS.NET server-side rendering tab
class SsrTabGenerator extends defaultGenerator_1.DefaultTemplateGenerator {
    activate(context, inputs) {
        const templateName = inputs[constants_1.QuestionNames.TemplateName];
        return [templateNames_1.TemplateNames.SsoTabSSR, templateNames_1.TemplateNames.TabSSR].includes(templateName);
    }
    async getTemplateInfos(context, inputs, destinationPath) {
        const templateName = inputs[constants_1.QuestionNames.TemplateName];
        const appName = inputs[constants_1.QuestionNames.AppName];
        const safeProjectNameFromVS = inputs[constants_1.QuestionNames.SafeProjectName];
        const solutionNameFromVS = inputs[constants_1.QuestionNames.SolutionName];
        const isNet8 = !inputs.targetFramework || inputs.targetFramework === "net8.0";
        const replaceMap = Object.assign(Object.assign({}, generator_1.Generator.getDefaultVariables(appName, safeProjectNameFromVS, solutionNameFromVS, inputs.targetFramework, inputs.placeProjectFileInSolutionDir === "true")), { IsNet8Framework: isNet8 ? "true" : "" });
        return Promise.resolve((0, teamsfx_api_1.ok)([
            {
                templateName: templateName,
                language: constants_1.ProgrammingLanguage.CSharp,
                replaceMap,
            },
        ]));
    }
}
exports.SsrTabGenerator = SsrTabGenerator;
//# sourceMappingURL=ssrTabGenerator.js.map